<template>
  <v-card style="background-color: rgb(236, 241, 242);">
    <div style="max-height: 480px; overflow-y: scroll">
      <v-data-table
        flat
        :headers="headers"
        :items="GetCourseCategories"
        :expanded="expanded"
        @click:row="clickRow"
        :hide-default-header="true"
        sortable
        :hide-default-footer="true"
        :options="{ itemsPerPage: -1 }"
        style="background-color: #ecf1f2"
      >
        <template v-slot:body="props">
          <draggable :list="props.items" tag="tbody" @end="handleDragEnd">
            <tr v-for="(projects, index) in props.items" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ projects.CategoryName }}</td>

              <!-- <td class="d-flex justify-end">
                <v-icon
                  class="pa-0"
                  @click="editItem(projects), (editdialog = true)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon class="ml-3 mr-2" @click="Delete(projects)">
                  mdi-delete-outline</v-icon
                >
              </td> -->
            </tr>
          </draggable>
        </template>
        <!-- <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length" class="pl-0 pr-0">
          <v-data-table
            flat
            :headers="peopleHeaders"
            :items="people"
            item-key="name"
            :hide-default-header="true"
            :hide-default-footer="true"
            class="pl-0 pr-0"
            outlined
          >
            <template v-slot:[`item.text`]="{ item }" class="pa-8 pl-2">
              <span>
                <v-edit-dialog>
                  <costumicon-2 />
                  <span class="pl-4"> {{ item.text }} </span>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.text"
                      label="Edit"
                      single-line
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </span>
            </template>
          </v-data-table>
        </td>
      </template> -->
      </v-data-table>
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="px-14 py-6 mb-2 text_trans"
        color="grey lighten-1"
        text
        @click="close()"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        class="px-14 py-6 mb-2 text_trans"
        :disabled="btnloader"
        @click="close()"
      >
        <span v-if="btnloader != true">save</span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </v-card-actions>
    <!-----------------edit dialog-------------------------------->
    <v-dialog v-model="editdialog" width="500" persistent>
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <h5>Edit Category</h5>
          <v-icon @click="editdialog = false">mdi-close</v-icon>
        </div>

        <div>
          <v-card color="#F6F8FC" flat class="px-3">
            <v-text-field
              v-model="editedItem.CategoryName"
              required
            ></v-text-field>
          </v-card>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="pa-3">
            <v-btn
              class="px-14 py-6 mb-2 text_trans"
              color="grey lighten-1"
              text
              @click="editdialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              class="px-14 py-6 mb-2 text_trans"
              @click="send()"
            >
              <v-progress-circular
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
              <span class="pa-4"> Edit </span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------------Delete dialog-------------------------------->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="DeleteItem"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// import costumicon from "../Video/costumicon.vue";
// import Costumicon2 from "../Video/costumicon2.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  name: "OrganizeComponent",
  //components: { costumicon, Costumicon2 },
  components: {
    draggable,
  },
  props: ["organizeDialog"],
  computed: {
    ...mapGetters(["GetCourseCategories"]),
  },
  data() {
    return {
      btnloader: false,
      dialog: false,
      dialogDelete: false,
      editdialog: false,
      expanded: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "Id",
        },
        {
          text: "",
          align: "left",
          value: "CategoryName",
        },
        { text: "", align: "right", value: "actions", sortable: false },
      ],
      projects: [
        {
          id: 1,
          name: "Anatomy and Physiology",
        },
        {
          id: 2,
          name: "AnimalTalk",
        },
        {
          id: 3,
          name: "BodyTalk Access",
        },
        {
          id: 4,
          name: "BodyTalk Courses",
        },
        {
          id: 5,
          name: "BreakThrough",
        },
        {
          id: 6,
          name: "CEUs",
        },
      ],
      peopleHeaders: [
        {
          text: "Text",
          align: "left",
          sortable: true,
          value: "text",
        },
      ],
      people: [
        {
          text: "Cortices",
        },
        {
          text: "Cortices How To",
        },
      ],
      editedItem: {
        Id: 0,
        CategoryName: "",
      },
      editedIndex: -1,
      desserts: [
        {
          name: "Learn the BodyTalk Cortices Technique",
        },
      ],
      deleteId: 0,
    };
  },

  methods: {
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },
    handleDragEnd(event) {
      const newOrder = event.newIndex;
      const itemId = event.item._underlying_vm_.Id;
      const payload = {
        sortNum: newOrder,
        Id: itemId,
      };
      this.$store.dispatch("SortCourseCategory", payload).then(() => {
        this.$store.dispatch("GetCourseCategories");
      });
    },
    Delete(item) {
      this.deleteId = item.Id;
      this.dialogDelete = true;
    },
    DeleteItem() {
      this.$store.dispatch("DeleteCourseCategory", this.deleteId).then(() => {
        this.dialogDelete = false;
        this.$emit("fetchData", "delete");
      });
    },
    send() {
      this.$store.dispatch("UpdateCourseCategory", this.editedItem).then(() => {
        this.editdialog = false;
        this.$emit("fetchData", "edit");
      });
    },
    editItem(item) {
      this.editedItem.CategoryName = item.CategoryName;
      this.editedItem.Id = item.Id;
      this.dialog = true;
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
/* table.v-table tbody td {
    height: 40px;
    border: none;
}
.theme--light.v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
table { border-collapse:collapse }
table td, table th {
  height: 40px; 
} */
</style>
